import Tool from "./Tools";
import session from "./Session";

export default {
  inLight(){
    let { inLight }= Tool.getRequestParam();
    inLight = inLight === '1' || session.getInLight()
    return inLight;
  }
}
